<template>
  <div class="offer-right-panel">
    <div class="offer-positions">
      <div class="offer-position" v-for="product in buildDataList">
        <div class="offer-photo">
          <img v-if="product.image == '/nophoto.png'" src="//cdn01.redbay.pl/layouts/boma/img/noimg.jpg" alt="brak zdjęcia" class="img-fluid" />
          <img v-else :src="getPhoto(product)" :alt="product.name" class="img-fluid" />
        </div>
        <div class="offer-name">
          <router-link :to="{ name: 'productPage', params:{id: product.product_id, slug: 'item'}}">
            {{product.name}}
          </router-link>
        </div>
        <div class="offer-unit"><span>Jednostka: {{product.unit}}</span></div>
        <div class="offer-values">
          <div class="offer-quantity">
            <span class="minus" @click="subQuantity(product)"></span>
            <span class="quantity">{{product.cart_quantity}}</span>
            <span class="plus" @click="addQuantity(product)"></span>
          </div>
          <div v-if="product.setPrice <= 0" class="offer-net">
            <span>netto</span>
            {{calculateClientOfferPriceString(product.clientPrice, product.tax, product.cart_quantity, 'net', currency(), offer.markupType,offer.markupValue)}}
          </div>
          <div v-else="" class="offer-net">
            <span>netto</span>
            {{calculateClientOfferPriceString(Number(product.setPrice), product.tax, product.cart_quantity, 'net', currency(), 'percent', 0)}}
          </div>

          <div v-if="product.setPrice <= 0" class="offer-gross">
            <span>brutto</span>
            {{calculateClientOfferPriceString(product.netPrice, product.tax, product.cart_quantity, 'gross', currency(), offer.markupType,offer.markupValue)}}
          </div>
          <div v-else="" class="offer-gross">
            <span>brutto</span>
            {{calculateClientOfferPriceString(Number(product.setPrice), product.tax, product.cart_quantity, 'gross', currency(), 'percent', 0)}}
          </div>
        </div>

      </div>
    </div>
    <div class="offer-bottom">
      <div class="offer-button" @click="goToOffer()">
        Konfiguracja oferty
      </div>
    </div>
  </div>
</template>


<script>

  import { mapState, mapGetters} from 'vuex';
  import CalculatePrice from 'redbay-b2b-products/src/product/CalculatePrice';
  import Cms from 'redbay-b2b-cms/src/Cms'
  import CartIcon from "vue-material-design-icons/cart.vue";


  export default {
    components: {CartIcon},

    computed: {
      ...mapState({
        offer: state => state.offer,
        productsList: state => state.offer.products,
        userSettings:  state => state.user.userSettings,
        userPrices: state => state.user.userPrices,

      }),
      ...mapGetters({
        currency: 'company/selectedCurrency'
      })
    },
    data() {
      return {
        units: {single:[], decimals: []},
        buildDataList: [],
        group: '',
        attributes: []
      }
    },
    watch: {
      productsList: async function () {
        this.buildDataList = await this.$store.dispatch('offer/getDataList', {
          attributes: this.attributes, prices: this.userPrices, group: this.group
        });
      }
    },


    methods: {
      ...CalculatePrice(),

      subQuantity(product) {
        if(product.cart_quantity > 0) {
          if (this.units.single.indexOf(product.unit) > 0) {
            product.cart_quantity--;
          }
          if (this.units.decimals.indexOf(product.unit) > 0) {
            product.cart_quantity = Math.round((product.cart_quantity - 0.001) * 1000) / 1000;
          }
          else{
            product.cart_quantity--;
          }
          this.modify(product);
        }
      },

      addQuantity(product) {
        if(product.cart_quantity < product.stock) {
          if (this.units.single.indexOf(product.unit) > 0) {
            product.cart_quantity++;
          }
          if (this.units.decimals.indexOf(product.unit) > 0) {
            product.cart_quantity = Math.round((product.cart_quantity + 0.001) * 1000) / 1000;
          }
          else{
            product.cart_quantity++;
          }
          this.modify(product);
        }
      },

      async modify(product) {
        this.$store.dispatch('offer/save', product);
      },

      getPhoto(product) {
        return Cms.replaceSizePhoto(product.image, 100, 125)
      },

      goToOffer() {
        this.$router.replace({name: 'offerConf'});
      },

    },

    async beforeMount() {
      this.group = this.userSettings['USER_GROUP'] ? this.userSettings['USER_GROUP'] : 0;
      this.attributes = this.$config.get('searchPage.visibleAttributes');
      this.units = this.$config.get('basket.units');
      if(this.offer.markupType == null) {
        this.offer.markupType = this.userSettings.B2B_CLIENT_MARGIN_TYPE;
        this.offer.markupValue = this.userSettings.B2B_CLIENT_MARGIN;
      }

      this.buildDataList = await this.$store.dispatch('offer/getDataList', {
        attributes: this.attributes, prices: this.userPrices, group: this.group
      });
    }
  }
</script>



// WEBPACK FOOTER //
// node_modules/redbay-b2b-offer/src/OfferRight.vue